module.exports = __webpack_public_path__ + "Ubuntu-BoldItalic.48c161df9991f9b0f6e4.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-BoldItalic.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-BoldItalic.ttf
// module chunks = styles